import { Loadable } from '../../../components/common/loadable/loadable';

export const ApplicationsContainer = Loadable<any>({
  loader: () =>
    import(/* webpackChunkName: "applications" */ './applications').then(
      (module) => module.ApplicationsContainer,
    ),
});
